function dasherize(str) {
    return str
        .trim()
        .replace('&amp;', '')
        .replace(/[^\w\s]/gi, '')
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/\s+/g, '-')
        .toLowerCase();
}

module.exports = {
    dasherize,
};
